import { Column, Row, Text } from '~/commonComponents';
import { Colors } from '~/themes/colors';
import StarIcon from '~/images/icons/StarIcon';

interface IRatingBreakdownProps {
  professionalSkills: number;
  interpersonalSkills: number;
  timeManagement: number;
}

const SKILL_CATEGORIES = [
  { key: 'professionalSkills', label: 'Professional Skills' },
  { key: 'interpersonalSkills', label: 'Interpersonal Skills' },
  { key: 'timeManagement', label: 'Time Management' },
] as const;

export const RatingBreakdown = ({
  professionalSkills,
  interpersonalSkills,
  timeManagement,
}: IRatingBreakdownProps) => {
  const values = { professionalSkills, interpersonalSkills, timeManagement };

  return (
    <Column gap={8} paddingVertical={8} paddingLeft={60} paddingRight={32}>
      <Text bold fontSize={18} color={Colors.neutral_600}>
        Average Rating
      </Text>
      {SKILL_CATEGORIES.map(({ key, label }) => (
        <Row key={key} alignItems="center" justifyContent="space-between">
          <Text fontSize={16} color={Colors.neutral_600}>
            {label}
          </Text>
          <Row alignItems="center" gap={4}>
            {Array.from({ length: 5 }).map((_, i) => (
              <StarIcon
                key={`${key}-star-${i}`}
                width={16}
                height={16}
                color={i < Math.floor(values[key]) ? undefined : Colors.neutral_200}
              />
            ))}
            <Text fontSize={16} color={Colors.neutral_600}>
              {values[key].toFixed(1)}
            </Text>
          </Row>
        </Row>
      ))}
    </Column>
  );
};
